import React from 'react'
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldError,
  RegisterOptions,
} from 'react-hook-form'
import { getYear } from 'date-fns'
import { YearPicker, YearPickerProps } from './YearPicker'

type Props = Omit<YearPickerProps, 'error' | 'value' | 'onChange'> & {
  control: Control
  name: string
  defaultValue?: number
  rules?: RegisterOptions
  error?: FieldError
}

export function ControlledYearPicker(props: Props): React.ReactElement {
  const { control, name, defaultValue, rules, error, ...inputProps } = props

  const currentYear = getYear(Date.now())

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? currentYear}
      rules={rules}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: number }) => (
        <YearPicker
          {...inputProps}
          value={value}
          onChange={(newValue) => onChange(newValue)}
          error={error?.message}
        />
      )}
    />
  )
}
